module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Wallet-16ccaaaec3c4aee1c870d873e45b0c65.svg";